export const getCoordinate = async (address: string): Promise<{ longitude: number; latitude: number } | null> => {
  if (!address) {
    return null;
  }

  const geocoder = new window.google.maps.Geocoder();

  return new Promise(resolve => {
    geocoder.geocode({ address }, (results, status) => {
      if (status === window.google.maps.GeocoderStatus.OK && results?.[0]) {
        const location = results[0].geometry.location;
        resolve({
          longitude: location.lng(),
          latitude: location.lat(),
        });
      } else {
        resolve(null);
      }
    });
  });
};
